<template>
  <div class="content">
        <div class="build-CURD">
          <div class="build-bar" style="justify-content: flex-end;padding: 0px 20px;display: flex;">
            <el-button type="primary" class="add-user" @click="addRow">添加</el-button>
          </div>
          <div class="build-table">
            <el-table
              :data="tableDataEnd"
              style="width: 100%;margin-bottom: 20px;"
              row-key="id"
              border
              default-expand-all
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column
                prop="name"
                label="事业部名称">
              </el-table-column>
              <el-table-column label="是否最末级">
                <template slot-scope="scope">
                  <span v-if="scope.row.endFlag==0">否</span>
                  <span v-else>是</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="sort"
                label="排序">
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="时间">
              </el-table-column>
              <el-table-column
                prop="remarks"
                label="备注">
              </el-table-column>
              <el-table-column label="树形展示">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.showStatusFlag"
                    disabled
                    active-text=""
                    inactive-text="">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  
                </template>
              </el-table-column>
            </el-table>
            <!-- 新增窗口 -->
            <el-dialog
              :title="dialogTitle"
              :visible.sync="addFormVisible"
              center
              width="500px"
              :append-to-body="true"
              :lock-scroll="false"
              class="add-form"
            >
              <el-form :model="addForm" label-width="120px" ref="ruleForm">
                <el-form-item label="上级事业部">
                  <el-input v-model="addForm.parentName" autocomplete="off" readonly @focus="innerVisible = true"></el-input>
                </el-form-item>
                <el-form-item label="事业部名称" prop="name" required>
                  <el-input v-model="addForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="是否最末端">
                  <el-radio-group v-model="addForm.endFlag">
                    <el-radio  label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="树形展示">
                  <el-radio-group v-model="addForm.showStatus">
                    <el-radio  label="1">展示</el-radio>
                    <el-radio label="2">隐藏</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="排序">
                  <el-input v-model="addForm.sort" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注" >
                  <el-input type="textarea" v-model="addForm.remarks"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="addFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('ruleForm')">确 定</el-button>
              </div>
              <!-- 内部弹出框 -->
              <el-dialog
                width="30%"
                title="事业部列表"
                :visible.sync="innerVisible"
                append-to-body>
                <el-tree :data="tableDataEnd" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="innerVisible = false">取 消</el-button>
                  <el-button type="primary"  @click="choseTree">确 定</el-button>
                </div>
              </el-dialog>
            </el-dialog>
          </div>
        </div>
  </div>
</template>

<script>
import myHttp from "../../untils/port.js";
import util from "../../untils/util.js"
import base from '../../untils/base'
var _index
export default {
  data() {
    return {
      labelPosition:'right',
      addForm:{
        entId:'',
        id:'',
        parentName:'',
        parentId:'',
        name:'',
        endFlag:'0',
        sort:'',
        remarks:'',
        showStatus:'1'
      },
      dialogTitle:'',
      addFormVisible: false,
      tableDataEnd: [],
      entId:'',
      innerVisible:false,
      parent:{
          name:'',
          id:''
      },
      defaultProps:{
        children: 'children',
        label: 'name'
      },
      initList:[],
      dataText:'数据加载中...',
    }
  },
  mounted(){
    this.entId = this.$store.state.groupId
    if(''==this.entId){
      this.$store.commit('setGroupId');
      this.entId = this.$store.state.groupId
    }
    this.addForm.entId = this.entId;
    this.getData()
  },
  methods: {
    doFilter() {
      this.$router.push({name: "attendArea"});
    },
    // 获取数据
    getData() {
      var that = this;
      myHttp.getOfficeList({
        entId:this.entId
      }).then(function(resp){
        if(resp.data.code=="200"){
            var list = resp.data.data.officeList||[];
            for(var i=0;i<list.length;i++){
              list[i].showStatusFlag = list[i].showStatus=='1'?true:false
            }
            that.initList = list;
            that.tableDataEnd = util.common.listToTree('id','parentId',list);
            if(list.length==0){
                that.dataText = "暂无数据"
            }
        }else{
          that.$message.error(resp.data.msg);
          that.dataText = "暂无数据"
        }
      },function(){});
    },
    // 新增数据
    addRow() {
      this.dialogTitle='添加事业部信息';
      this.addFormVisible = true;
      this.addForm = {
        id:'',
        entId:this.addForm.entId,
        parentName:'',
        parentId:'',
        name:'',
        endFlag:'0',
        sort:'',
        remarks:'',
        showStatus:''
      }
    },
    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
          if (valid) {
            if(that.addForm.id==""){
              delete that.addForm.id;
              myHttp.createOffice(that.addForm).then(function (resp) {
                  if (resp.data.code == "200") {
                    that.$message.success('添加成功');
                    that.getData();
                    that.addFormVisible = false
                  } else {
                    that.$message.error(resp.data.msg);
                  }
              }, function (error) {
                  that.$message.error("服务器繁忙，请稍候再试");
              });
            }else{
              myHttp.updateDept(that.addForm).then(function (resp) {
                  if (resp.data.code == "200") {
                      that.$message.success('修改事业部成功');
                      that.getData();
                      that.addFormVisible = false
                  } else {
                      that.$message.error(resp.data.msg);
                  }
              }, function (error) {
                  that.$message.error("服务器繁忙，请稍候再试");
              });
            }
          }
      });
      // this.addForm.id = this.projectId;
      // myHttp.updateProRules(this.addForm).then(function(resp){
      //   if(resp.data.code=="200"){
      //       that.$message.success("修改成功");
      //       that.addFormVisible = false;
      //       that.getData();
      //   }else{
      //     that.$message.error(resp.data.msg);
      //   }
      // },function(){});
    },
    cancel() {
      this.addFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.addFormVisible = false
    },

    //菜单树弹点击事件
    handleNodeClick(data){
      this.parent.name = data.name;
      this.parent.id = data.id;
    },
    //点击确认
    choseTree(){
      this.addForm.parentName = this.parent.name;
      this.addForm.parentId = this.parent.id;
      this.innerVisible = false;
    },
    //修改
    handleEdit(index,row){
      console.log(row);
      this.addForm = {
        id:row.id,
        entId:this.addForm.entId,
        parentName:this.getNameById(row.parentId),
        parentId:row.parentId,
        name:row.name,
        endFlag:row.endFlag,
        sort:row.sort,
        remarks:row.remarks,
        showStatus:row.showStatus
      }
      this.dialogTitle='修改事业部信息';
      this.addFormVisible = true;
    },
    //获取名称
    getNameById(id){
      var list = this.initList;
      var result = '';
      for(var i=0;i<list.length;i++){
        if(id==list[i].id){
          result = list[i].name;
        }
      }
      return result;
    },
    //删除
    handleDelete(index,row){
      var that = this;
      this.$alert('确认删除该事业部吗？', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          myHttp.deleteDept({
            id:row.id
          }).then(function(resp){
            if(resp.data.code=="200"){
              that.$message.success("删除成功");
              that.getData();
            }else{
              that.$message.error(resp.data.msg);
            }
          },function(){});
        }
      });
    },

    // //监听组织管理显示状态
    // changeSwitch(row){

    // },

  }
}
</script>

<style>
@import '../../assets/css/common.css';
</style>

<style scoped>
* {
  box-sizing: border-box;
}
.el-table--border{
      border: 1px solid #ebeef5;
}
.content{
  height: 100%;
  width: 100%;
  background: #fff;
}
.build-CURD{
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table{
  height: calc( 100% - 160px );
  padding: 20px;
  width: 100%;
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user  >>> span {
 text-align: center;
 margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}
.box-text{
  width: 200px;
}
.build-table .el-row{
  margin-bottom: 30px;
}
.box-name{
  display: inline-block;
  width: 120px;
  text-align: right;
}
.digoutHead{
  width:100%;height:40px;background:#f2f2f2;display:flex;align-items: center;
}
.digooutBox{
  width:100%;height:60px;display:flex;padding:10px 0;
}
.box-item1{
  width:50%;padding-left:10px;
}
</style>
<style>
   .menuAdmin .el-form-item__content{
     text-align: left;
   }
   .menuAdmin .el-dialog{
      padding-right: 20px;
    }
    .is-current>.el-tree-node__content{
      color: #409EFF;
    }
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>